export const API_SET_CONFIGURATION = "API_SET_CONFIGURATION";

export const setConfiguration = (payload) => ({
  type: API_SET_CONFIGURATION,
  payload,
});
